import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { INodeHandle } from 'types';

import * as S from './PrimaryNode.styled';

type IProps = {
  data: {
    label: string;
    color?: string;
    handle: INodeHandle[];
  };
};

export const PrimaryNode = ({ data: { label, color, handle } }: IProps) => (
  <>
    {handle.map(({ position, type }, index) => (
      <S.Handle key={position} position={position} type={type} id={String(index)}>
        <ArrowForwardIcon />
      </S.Handle>
    ))}
    <S.Container color={color}>
      <S.Label>{label}</S.Label>
    </S.Container>
  </>
);
